import { IdentityReferenceItem } from '@reg/shared/model';

/**
 * Model to a ranking calculation reference item
 */
export class IdentityRankingCalculation extends IdentityReferenceItem {
    public static INSTANCE_OF_NAME: string = 'RankingCalculation';

    public clone(): IdentityRankingCalculation {
        return <IdentityRankingCalculation> super.clone();
    }

    public deserialize(json: Object): IdentityRankingCalculation {
        return <IdentityRankingCalculation> super.deserialize(json);
    }
}
